import { render } from "./UserLayout.vue?vue&type=template&id=27b8e307&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=ts"
export * from "./UserLayout.vue?vue&type=script&lang=ts"

import "./UserLayout.vue?vue&type=style&index=0&id=27b8e307&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27b8e307"

export default script